import { CreateInquiryRequest } from 'models/inquiry';
import { Reservation } from 'models/reservation';

export interface InquiryFormValues {
  givenName: string;
  familyName: string;
  email: string;
  category: string;
  title: string;
  body: string;
}

export const getInitialValues = (reservation: Reservation | null): InquiryFormValues => {
  const givenName =
    reservation?.field_responses.find((response) => response.key === 'given_name')?.response ??
    reservation?.field_responses.find((response) => response.key === 'kana_given_name')?.response ??
    '';
  const familyName =
    reservation?.field_responses.find((response) => response.key === 'family_name')?.response ??
    reservation?.field_responses.find((response) => response.key === 'kana_family_name')
      ?.response ??
    '';

  return {
    givenName: givenName,
    familyName: familyName,
    email:
      reservation?.field_responses.find((response) => response.key === 'email')?.response ?? '',
    category: '',
    title: '',
    body: '',
  };
};

export const convertFormValuesToSwagger = (
  reservationId: string,
  values: InquiryFormValues
): CreateInquiryRequest => {
  return {
    reservation_id: reservationId,
    email: values.email,
    customer_given_name: values.givenName,
    customer_family_name: values.familyName,
    subject: values.title,
    body: values.body,
    inquiry_category: values.category,
  };
};
